import React from "react";
import "./games-items.scss";
import ShowContainer from "../ShowContainer";
import LoaderContainer from "../loader_container/LoaderContainer";
import GameItemSupportBonus from "../game_tem/GameItemSupportBonus";
import NoGames from "./NoGames";

export default function GamesItems({ games, loader, noGames }) {
  return (
    <LoaderContainer center loader={loader}>
      <ShowContainer
        condition={games.length}
        plug={
          <ShowContainer condition={noGames}>
            <NoGames />
          </ShowContainer>
        }>
        <div className="games__games">
          {games.map((el) => (
            <GameItemSupportBonus
              key={el.game_id}
              currentGame={el}
              name={el.name}
              image={el.image}
            />
          ))}
        </div>
      </ShowContainer>
    </LoaderContainer>
  );
}
